import { createSelector, createFeatureSelector } from '@ngrx/store';

import { IState } from '@models/index';

export const countrySelector = createFeatureSelector<IState>('country');
export const getCountrySelector = createSelector(countrySelector, (state: IState) => state); 
